import React from "react";

import { useState } from "react";

// import "./NavMobile.scss";

import { withRouter } from "react-router";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuOpen = () => setMenuOpen(true);
  const handleMenuClose = () => setMenuOpen(false);

  return (
    <>
      <>
        <nav className="navigation">
          <div className="navigation__container  navigation__container--wol">
            <div className="navigation__logo">
              <a href="/">
                <img
                  src="data:image/svg+xml;base64,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"
                  alt="LoanPal"
                />
              </a>
            </div>
            <nav className="navigation__menu navigation__menu--principal">
              <div>
                <a
                  className="navigation__link"
                  href="/about-us/"
                >
                  About Us
                </a>
              </div>
              <div>
                <a
                  className="navigation__link"
                  href="/what-we-do/"
                >
                  What we do
                </a>
              </div>
              <div>
                <a
                  href="/contact-us"
                  className="navigation__link"
                >
                  Contact us
                </a>
              </div>
            </nav>
            <nav className="navigation__menu navigation__menu--secondary">
              <div>
                <div className="GroupedMenu">
                  <div className="GroupedMenu__Name">Partner Center</div>
                  <ul className="GroupedMenu__Options">
                    <li>
                      <a
                        href="https://partner-admin.loanpal.com/login"
                        className="GroupedMenu__Link"
                      >
                        Partner Portal
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://investors.loanpal.com/login"
                        className="GroupedMenu__Link"
                      >
                        Investor Portal
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <div className="GroupedMenu">
                  <div className="GroupedMenu__Name">My Account</div>
                  <ul className="GroupedMenu__Options">
                    <li>
                      <a
                        href="https://www.yourmortgageonline.com/?conn=B66F1218-E20C-4EDB-9C45-7B9DE96EFE9F"
                        className="GroupedMenu__Link"
                      >
                        Home Loan Payment
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.billerpayments.com/app/cust/login.do?bsn=loanpalmain"
                        className="GroupedMenu__Link"
                      >
                        Solar Loan Payment
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
            <button
              className="navigation__hamburger navigation__hamburger--wol"
              type="button"
              aria-label="open mobile menu"
              onClick={() => handleMenuOpen()}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>
        {/* */}
        {true && (
          <div
            className={`navigation-mobile navigation-mobile--${
              menuOpen ? "open" : "closed"
            }`}
          >
            <div
              className="navigation-mobile__overlay"
              onClick={() => handleMenuClose()}
              onKeyDown={() => handleMenuClose()}
              role="presentation"
            />
            <div className="navigation-mobile__wrapper">
              <div className="navigation-mobile__container">
                <button
                  className="navigation-mobile__close"
                  type="button"
                  onClick={() => handleMenuClose()}
                >
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHdpZHRoPSIyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIxNCIgY3k9IjE0IiBmaWxsPSIjZDlkNWQ1IiByPSIxNCIvPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiPjxwYXRoIGQ9Im0wIDBoMTciIHRyYW5zZm9ybT0ibWF0cml4KC43MDcxMDY3OCAuNzA3MTA2NzggLS43MDcxMDY3OCAuNzA3MTA2NzggOC4wMTA2NzUgOC4wMTA4ODcpIi8+PHBhdGggZD0ibTAgMGgxNyIgdHJhbnNmb3JtPSJtYXRyaXgoLS43MDcxMDY3OCAuNzA3MTA2NzggLS43MDcxMDY3OCAtLjcwNzEwNjc4IDIwLjAzMTQ5IDguMDEwODg3KSIvPjwvZz48L3N2Zz4="
                    alt="Close"
                  />
                </button>
                <div className="navigation-mobile__menu">
                  <div className="navigation-mobile__menu_top">
                    <a
                      aria-current="page"
                      className="navigation-mobile__link"
                      href="https://goodleap.com/"
                    >
                      Home
                    </a>
                    <a
                      className="navigation-mobile__link"
                      href="https://goodleap.com/about-us/"
                    >
                      About Us
                    </a>
                    <a
                      className="navigation-mobile__link"
                      href="https://goodleap.com/what-we-do/"
                    >
                      What We Do
                    </a>
                    <a
                      href="https://legacy.loanpal.com/contact-us"
                      className="navigation-mobile__link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contact Us
                    </a>
                  </div>
                  <div className="navigation-mobile__menu_bottom">
                    <a
                      href="https://partner-admin.loanpal.com/login"
                      className="navigation-mobile__link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Partner Portal
                    </a>
                    <a
                      href="https://investors.loanpal.com/login"
                      className="navigation-mobile__link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Investor Portal
                    </a>
                    <a
                      href="https://www.yourmortgageonline.com/?conn=B66F1218-E20C-4EDB-9C45-7B9DE96EFE9F"
                      className="navigation-mobile__link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Home Loan Payment
                    </a>
                    <a
                      href="https://www.billerpayments.com/app/cust/login.do?bsn=loanpalmain"
                      className="navigation-mobile__link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Solar Loan Payment
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* */}
      </>
    </>
  );
};

export default withRouter(Header);
